import { computed, inject, Injectable, Signal } from '@angular/core';
import { ApiService } from './api.service';
import { HttpResourceRef } from '@angular/common/http';
import { Sign } from 'crypto';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private apiService: ApiService = inject(ApiService);
  public profileRessources: HttpResourceRef<any | undefined> = this.apiService.getProfileRessources;

  public profile: Signal<any | undefined> = this.profileRessources.value;
  private readonly maskedRoles: string[] = ['ROLE_USER', 'ROLE_UPLOAD_FHD', 'ROLE_BETA'];

  public avatarUrl: Signal<string | null> = computed(() => {
    return this.profile()?.avatar_url || null;
  });

  public readonly isAdmin: Signal<boolean> = computed(() => this.profile()?.is_admin ?? false);

  public roles: Signal<string[]> = computed(() => {
    const profile: any = this.profile();
    return profile?.roles.filter((role: string) => !this.maskedRoles.includes(role)) || [];
  });

  /**
   * Le **nombre totale de tout les contenus uploadé** par le client disponible sur l'application.
   * !!Manque une donnée coté back, demande beaucoup d'appels pour la calculer coté front!!
   */
  public readonly pendingContentCount: Signal<number> = computed(() => 9);

  /**
   * Le **nombre totale de tout les contenus uploadé** par le client disponible sur l'application.
   * !!Manque une donnée coté back, demande beaucoup d'appels pour la calculer coté front!!
   */
  public readonly inAppContentCount: Signal<number> = computed(() => 9);

  /**
   * Le **nombre totale des sessisons sur le contenu uploadé du client** disponible sur l'application.
   * tout type de contenus confondu.
   * !!Manque une donnée coté back, demande beaucoup d'appels pour la calculer coté front!!
   */
  public readonly inAppSessionsCount: Signal<number> = computed(() => 4237);
}
